import api from '@/lib/axios';
import type { SetupModuleKey, SetupModuleState } from '@/lib/setupModules';

export interface SetupState {
  status: 'in_progress' | 'complete';
  moduleOrder?: SetupModuleKey[];
  modules?: Record<SetupModuleKey, {
    state: SetupModuleState;
    conciergeRequestId?: string | null;
    updatedAt?: string;
  }>;
  // Sample/demo records were seeded into empty areas and not yet purged.
  hasDemoData?: boolean;
}

export const setupService = {
  getSetup: async (): Promise<SetupState> => {
    const response = await api.get('/api/setup');
    return response.data;
  },
  start: async (moduleOrder: SetupModuleKey[]) => {
    const response = await api.post('/api/setup/start', { moduleOrder });
    return response.data;
  },
  updateModule: async (moduleKey: SetupModuleKey, state: 'viewed' | 'kept_templates' | 'skipped' | 'started_fresh') => {
    const response = await api.patch(`/api/setup/modules/${moduleKey}`, { state });
    return response.data;
  },
  startFresh: async (moduleKey: SetupModuleKey) => {
    const response = await api.post(`/api/setup/modules/${moduleKey}/start-fresh`);
    return response.data;
  },
  removeDemoData: async () => {
    const response = await api.delete('/api/setup/demo-data');
    return response.data;
  },
  trackEvent: (event: string, module?: string, metadata?: Record<string, unknown>): void => {
    // fire-and-forget — never block or throw
    try {
      api.post('/api/setup/events', { event, module, metadata }).catch(() => {});
    } catch {
      /* noop */
    }
  },
  createRequest: async (moduleKey: SetupModuleKey, files: File[], note: string) => {
    const formData = new FormData();
    formData.append('module', moduleKey);
    formData.append('note', note);
    files.forEach((f) => formData.append('files', f));
    const response = await api.post('/api/setup/requests', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000
    });
    return response.data;
  }
};
